import { useTranslation } from "react-i18next";
import { JobOfferPayload } from "../../../../models/candidate-action.model";
import { jobOfferStatusTypes } from "../../../../models/candidate.model";
import { Field, Infos, Modal, Skill } from "../../../job-offer/joboffer.styled";
const ModalJobOfferElement = document.getElementById("modal-joboffer");

const JobOfferResumeModal: React.FC<{
  toggle: () => void;
  isShown: boolean;
  joboffer: {
    status: jobOfferStatusTypes;
    metadata: JobOfferPayload;
  };
}> = ({ joboffer, isShown, toggle }) => {
  const { t } = useTranslation("private-home-page");

  return (
    <Modal
      width={500}
      isShown={isShown}
      toggle={() => toggle()}
      target={ModalJobOfferElement}
      handleClose={() => toggle()}
    >
      <Infos>
        <Skill>
          <p>{`${t("jobOffer.modal.coreTechnology")}${
            joboffer.metadata.main_skill
          }`}</p>
        </Skill>

        <Field>
          <p>{`${t("jobOffer.modal.salary")} ${
            joboffer.metadata?.salary && joboffer.metadata?.currency 
              ? `${joboffer.metadata?.currency} ${joboffer.metadata?.salary}`
              : t("jobOffer.modal.notInformed")
          }`}</p>
        </Field>

        {joboffer.metadata?.hire_types && (
          <Field>
            <p>
              {`${t("jobOffer.modal.hireType")} 
            ${
              Array.isArray(joboffer.metadata.hire_types) &&
              joboffer.metadata.hire_types?.join(" - ")
            }`}
            </p>
          </Field>
        )}
        <Field>
          {joboffer.metadata?.work_type ? (
            <p>{`${t(
              "jobOffer.modal.workType"
            )} ${joboffer.metadata?.work_type?.join(" - ")}`}</p>
          ) : (
            <p>{`${t("jobOffer.modal.workType")} ${t(
              "jobOffer.modal.notInformed"
            )}`}</p>
          )}
        </Field>
        {joboffer.metadata?.workplace && (
          <Field>
            <p>{`${t("jobOffer.modal.city")}${
              joboffer.metadata?.workplace || t("jobOffer.modal.notInformed")
            }`}</p>
          </Field>
        )}
        {joboffer.metadata?.diversity && (
          <Field>
            <p>{`${t("jobOffer.modal.diversity")} ${
              joboffer.metadata?.diversity?.join(" - ") ||
              t("jobOffer.modal.notInformed")
            }`}</p>
          </Field>
        )}
      </Infos>
    </Modal>
  );
};

export default JobOfferResumeModal;
